
import React from "react";
import { Control } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { DemographicsFormValues } from "./types";

interface ResidenceFieldProps {
  control: Control<DemographicsFormValues>;
}

export const ResidenceField: React.FC<ResidenceFieldProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="residence_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Residence Type</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select residence type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="urban">Urban</SelectItem>
              <SelectItem value="suburban">Suburban</SelectItem>
              <SelectItem value="rural">Rural</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
